module.exports = __webpack_public_path__ + "img/notfounded2.73866a34.png";